<template>
  <div class="container">
    <modal-info :html="html"></modal-info>
    <div class="column is-6 is-offset-3">
      <formulario-inscripcion-2 />
    </div>
  </div>
</template>

<script>
import ModalInfo from "@/components/ModalInfo";
import FormularioInscripcion2 from "@/components/FormularioInscripcion2.vue";
export default {
  name: "inscripcion",
  components: {
    FormularioInscripcion2,
    ModalInfo
  },
  data: function () {
    return {};
  },
  computed: {
    cedula: function () {
      return this.$store.getters.cedula;
    },
    datosCPE: function () {
      return this.$store.getters.getDatosCPE;
    },
    datosMEN: function () {
      return this.$store.getters.getDatosMEN;
    },
    html: function () {
      return this.$store.getters.getEstrategia.texto_informativo;
    }
  },
  methods: {},
  mounted() {}
};
</script>

<style></style>
